(function () {
  let isBroadcastChannelSupported = false;

  try {
    if (window.BroadcastChannel) {
      const broadcastChannel = new BroadcastChannel('tl_broadcast_channel');

      broadcastChannel.addEventListener('message', (event) => {
        const action = event.data.action;
        const eventName = event.data.event;
        const data = event.data.data;
        if (action === 'dispatchEvent') {
          window.dispatchEvent(new CustomEvent(eventName, {'detail': data}));
        } else if (action === 'update-local-cart') {
          window.cartManager.updateLocalCart(data);
        }
      });

      isBroadcastChannelSupported = true;
    } else {
      throw 'BroadcastChannel not supported.'
    }
  } catch (err) {
    console.error(err);
    isBroadcastChannelSupported = false;
  }

  const dispatchEvent = (eventName = '', data = {}) => {
    if (!isBroadcastChannelSupported) {
      window.dispatchEvent(new CustomEvent(eventName, {'detail': data}));
      return;
    }

    const broadcastChannel = new BroadcastChannel('tl_broadcast_channel');
    broadcastChannel.postMessage({action: 'dispatchEvent', event: eventName, data: data});
    broadcastChannel.close();
  }

  const dispatchEvents = (events = []) => {
    if (!Array.isArray(events) || !events.length) {
      console.error('BroadcastChannel: dispatchEvents method expects an array of events.');
      return;
    }

    if (!isBroadcastChannelSupported) {
      events.forEach(event => {
        if (typeof event === 'string') {
          window.dispatchEvent(new CustomEvent(event));
        } else if (typeof event === 'object') {
          window.dispatchEvent(new CustomEvent(event.name, {'detail': event.data}));
        }
      });
      return;
    }

    const broadcastChannel = new BroadcastChannel('tl_broadcast_channel');
    events.forEach(event => {
      if (typeof event === 'string') {
        broadcastChannel.postMessage({action: 'dispatchEvent', event: event});
      } else if (typeof event === 'object') {
        broadcastChannel.postMessage({action: 'dispatchEvent', event: event.name, data: event.data});
      }
    });
    broadcastChannel.close();
  }

  const updateLocalCart = (data = {}) => {
    if (!isBroadcastChannelSupported) {
      window.cartManager.updateLocalCart(data);
      return;
    }

    const broadcastChannel = new BroadcastChannel('tl_broadcast_channel');
    broadcastChannel.postMessage({action: 'update-local-cart', data: data});
    broadcastChannel.close();
  }

  const closeBroadcastChannel = () => {
    broadcastChannel.close();
  }

  window.broadcastChannel = {
    dispatchEvent,
    dispatchEvents,
    updateLocalCart,
    closeBroadcastChannel
  }
})()
